<template>
    <div class="w-100">
        <div class="input-group">

            <span class="input-group-text border-start-0">
                <i class="far fa-map-marker-alt form-control-feedback m-0"></i>
            </span>
            <input id="geo-lookup"
                   ref="lookupElement"
                   :placeholder="provider.getConfig('searchWherePlaceholder')"
                   autocomplete="off"
                   class="form-control dropdown-toggle border rounded-0 border-start-0 ps-0"
                   type="text"
                   @blur="lookupFocused=false"
                   @focus="lookupFocused=true"
                   @keyup="provider.setGeoLookup($event.target?.value)">
            <ul id="geo-suggestion" :class="{show: geoSuggestions.length > 0 && lookupFocused}" class="dropdown-menu">
                <li v-for="suggestion in geoSuggestions">
                    <a class="dropdown-item"
                       @mousedown="setLocation(suggestion.text_val, suggestion.loc_id)"
                    > {{ suggestion.text_val }} </a>
                </li>
            </ul>

            <template v-if="provider.getConfig('show_radius_filter')">
                <button :class="provider.getConfig('btnGeoClass')"
                        aria-expanded="false"
                        class="btn dropdown-toggle"
                        data-bs-toggle="dropdown"
                        type="button">
                    {{ radii[radius] }}
                </button>
                <ul id="select-radius" class="dropdown-menu">
                    <li v-for="(label, key) in radii">
                        <a :class="{active: key === radius}"
                           class="dropdown-item"
                           @click="provider.setLocationRadius(key)"
                        >{{ label }}</a>
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>

import {inject, ref, onMounted, computed, watch} from "vue";
import {KeyJobApiProvider} from "../symbols.ts";
import type JobApiProvider from "../JobApiProvider.ts";

const radii = {
    "": "Genauer Standort",
    "10": "10km",
    "20": "20km",
    "30": "30km",
    "40": "40km",
    "50": "50km",
    "75": "75km",
    "100": "100km",
}

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const location = provider.getLocation();
const radius = computed(() => location.value?.radius ?? '');

const lookupElement = ref<HTMLInputElement>();
const lookupFocused = ref(false);

const geoSuggestions = provider.geoSuggestions();

const setLocation = (geo: string, geoId: number) => {
    if (lookupElement.value) {
        lookupElement.value.value = geo;
    }
    provider.setLocation(geo, geoId);
}

watch(location.value, (newLoc) => {
  if (lookupElement.value) {
    lookupElement.value.value = newLoc.geo ?? '';
  }
});

onMounted(() => {
  if (location.value.geo && lookupElement.value) {
    lookupElement.value.value = location.value.geo;
  }
});

</script>
